export default "__VITE_ASSET__Bfv2gV$7__"